Apt.fn.make('ads', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @param {Function} [options.target]
	 * @param {Function} options.units
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;

		priv.options = options;
		priv.uid = LS.util.uid();
		priv.floor = 2;
		priv.ads = {};

		window.googletag = window.googletag || {};
		window.googletag.cmd = window.googletag.cmd || [];

		window.pbjs = window.pbjs || {
			que: []
		};

		LS.util.load('prebid', () => {
			priv.setup();
		}, true, false);

		return scope;
	},

	/**
	 * Load ads
	 */
	load() {
		this.$private.setup(true);
	},

	/**
	 * Unload module
	 */
	unload() {
		const priv = this.$private;
		const uid = priv.uid;

		clearTimeout(priv.delay);

		$.events.reset(uid);
		$.scroll.reset(uid);

		if (priv.empty) {
			try {
				googletag.pubads()
					.removeEventListener('slotRenderEnded', priv.empty);
			} catch (e) {
				//
			}

			priv.empty = null;
		}

		for (const ad of Object.values(priv.ads)) {
			googletag.cmd.push(() => {
				googletag.destroySlots([
					ad.slot
				]);
			});

			if (pbjs.removeAdUnit) {
				pbjs.removeAdUnit(ad.unit);
			}
		}

		priv.ads = {};
		priv.units = null;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const scope = this;
		const priv = scope.$private;

		if (priv.units) {
			scope.unload();
		}

		priv.uid = null;
	}
}, {
	/**
	 * Map format sizes
	 */
	formats: {
		card: [
			'fluid',
			[360, 300],
			[336, 336],
			[336, 280],
			[320, 320],
			[320, 250],
			[300, 300],
			[300, 250],
			[250, 250],
			[320, 160],
			[200, 200],
			[320, 100],
			[300, 100],
			[180, 150]
		]
	},

	/**
	 * Map ad placements
	 */
	placements: {
		property: 'property-card',
		properties: 'properties-card'
	},

	/**
	 * Load ads
	 *
	 * @param {Boolean} [display=false]
	 */
	setup(display) {
		const scope = this;
		const fn = () => {
			if (called) {
				return;
			}

			called = true;

			scope.fetch();
			scope.display();
		};

		let called;

		scope.units = scope.options.units();

		clearTimeout(scope.delay);

		if (! scope.units.length) {
			return;
		}

		scope.context = Apt.panel.opened() ?
			'$panelInner' : null;

		if (window.crawler) {
			scope.units.closest('.unit')
				.hide();

			return;
		}

		if (display || document.documentElement.scrollTop || scope.units.visible()) {
			fn();

			return;
		}

		$(Apt.panel.opened() ? '$panelInner' : window).on('scroll', fn, {
			namespace: scope.uid,
			once: true
		});

		scope.delay = setTimeout(fn, 3000);
	},

	/**
	 * Fetch ad assets
	 */
	fetch() {
		const scope = this;

		if (Apt.ads.loaded) {
			return;
		}

		Apt.ads.loaded = true;

		$.assets.load({
			js: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
			error: () => {
				scope.recover();
			}
		});

		pbjs.que.push(() => {
			pbjs.setConfig({
				bidderTimeout: 800,
				enableTIDs: true,
				consistentTIDs : true,
				priceGranularity: {
					buckets: [
						{
							max: 15,
							increment: 0.01
						},
						{
							max: 30,
							increment: 0.05
						},
						{
							max: 60,
							increment: 0.25
						},
						{
							max: 120,
							increment: 0.5
						}
					]
				}
			});

			pbjs.bidderSettings = {
				cordless: {
					bidCpmAdjustment: cpm => cpm * .7
				}
			};
		});
	},

	/**
	 * Display ads
	 */
	display() {
		const scope = this;

		scope.units.each((el, index) => {
			const width = $(el).width();
			const sizes = scope.formats[el.dataset.format]
				.filter(size => ! Array.isArray(size) || width >= size[0]);

			if (sizes.length) {
				el.id = 'ad-' + LS.util.uid();

				scope.ads[el.id] = {
					el: el,
					unit: '/22218592200/' + scope.placements[el.dataset.unit],
					position: el.dataset.position || (index + 1),
					sizes: sizes
				};
			}
		});

		if (! Object.keys(scope.ads).length) {
			return;
		}

		const targeting = Object.assign(
			$.context('targeting', {}),
			scope.options.targeting ?
				scope.options.targeting() : {}
		);

		const keywords = [
			'land',
			'real estate'
		];

		for (const [key, value] of Object.entries(targeting)) {
			if (! Array.isArray(value)) {
				targeting[key] = value.toString();
			}

			$.toArray(value).forEach(value => {
				if (typeof value === 'string' && value.length > 1) {
					keywords.push(value.replace(/-/g, ' '));
				}
			});
		}

		targeting.env = $.env();

		targeting.theme = LS.common.isDark() ?
			'dark' : 'light';

		const restricted = LS.user.restricted();
		const changed = restricted !== scope.restricted;

		scope.restricted = restricted;

		const info = {
			language: 'en',
			cat: [
				'IAB21',
				'IAB21-3'
			],
			content: {
				keywords: keywords.join(', ')
			}
		};

		const url = 'https://www.landsearch.com' + location.pathname;

		pbjs.que.push(() => {
			const config = {
				pageUrl: url,
				site: info,
				ortb2: {
					site: info
				}
			};

			if (changed) {
				scope.privacy(config, restricted);
			}

			pbjs.setConfig(config);

			pbjs.setBidderConfig({
				bidders: ['cordless'],
				config: {
					ortb2: {
						site: {
							ext: {
								attr: $.context('cordless', {})
							}
						}
					}
				}
			});

			pbjs.bidderSettings.cordless.ortb2 = {
				site: {
					ext: {
						attr: $.context('cordless', {})
					}
				}
			};
		});

		if (changed) {
			googletag.cmd.push(() => {
				googletag.pubads()
					.setPrivacySettings({
						restrictDataProcessing: restricted
					});
			});
		}

		googletag.cmd.push(() => {
			if (! scope.uid) {
				return;
			}

			if (! Apt.ads.allowed) {
				const received = () => {
					Apt.ads.allowed = true;

					try {
						scope.units.parent()
							.removeClass('-recover');

						googletag.pubads()
							.removeEventListener('slotResponseReceived', received);
					} catch (e) {
						//
					}
				};

				googletag.pubads()
					.addEventListener('slotResponseReceived', received);
			}

			scope.empty = event => {
				if (! event.isEmpty) {
					return;
				}

				const id = event.slot.getSlotElementId();
				const ad = scope.ads[id];

				if (! ad) {
					return;
				}

				const winner = pbjs.getHighestCpmBids(ad.unit)
					.find(bid => bid.cpm >= scope.floor);

				if (winner) {
					LS.util.load('ads-render', () => {
						Apt['ads-render'].display(ad, winner);
					}, scope.uid);

					return;
				}

				if (scope.options.empty) {
					const $ad = $('#' + id)
						.closest('$ad');

					$ad.removeClass('unit');

					scope.options.empty($ad);
				}
			};

			googletag.pubads()
				.addEventListener('slotRenderEnded', scope.empty);

			googletag.setConfig({
				adsenseAttributes: {
					page_url: url
				}
			});

			for (const [id, ad] of Object.entries(scope.ads)) {
				const slot = googletag.defineSlot(ad.unit, ad.sizes, id);

				slot.setConfig({
					targeting: Object.assign({
						position: ad.position.toString()
					}, targeting)
				});

				slot.addService(
					googletag.pubads()
				);

				ad.slot = slot;
			}

			if (! Apt.ads.enabled) {
				Apt.ads.enabled = true;

				googletag.setConfig({
					disableInitialLoad: true
				});

				googletag.enableServices();
			}

			Object.keys(scope.ads).forEach(id => {
				googletag.display(id);
			});

			scope.refresh(scope.uid);
		});
	},

	/**
	 * Update privacy config
	 *
	 * @param {Object} config
	 * @param {Boolean} [restricted=false]
	 */
	privacy(config, restricted = false) {
		config.deviceAccess = ! restricted;

		pbjs.bidderSettings.storageAllowed = ! restricted;

		if (restricted) {
			config.ortb2.regs = {
				us_privacy: '1YYN'
			};
			config.userSync = {
				iframeEnabled: false,
				imageEnabled: false,
				syncEnabled: false,
				userIds: []
			}

			return;
		}

		config.userSync = {
			iframeEnabled: true,
			filterSettings: {
				iframe: {
					bidders: '*',
					filter: 'include'
				}
			},
			userIds: [
				{
					name: 'sharedId',
					storage: {
						expires: 365,
						name: '_sharedid',
						type: 'html5'
					}
				}
			]
		}
	},

	/**
	 * Refresh ad units on scroll
	 *
	 * @param {String} namespace
	 */
	refresh(namespace) {
		const scope = this;

		let checked;

		if (! scope.units) {
			return;
		}

		scope.units.each(el => {
			LS.util.scrolled(el, namespace, e => {
				const ad = scope.ads[e.target.id];
				const handle = () => {
					scope.handle(ad);
				};

				if (ad) {
					pbjs.que.push(() => {
						scope.add(ad);

						pbjs.requestBids({
							adUnitCodes: [
								ad.unit
							],
							bidsBackHandler: handle
						});
					});

					setTimeout(handle, 1000);

					if (! checked && ! Apt.ads.allowed) {
						checked = true;

						setTimeout(() => {
							scope.recover();
						}, 3500);
					}
				}
			}, {
				context: scope.context,
				margin: scope.options.margin(el)
			});
		});
	},

	/**
	 * Add unit
	 *
	 * @param {Object} ad
	 */
	add(ad) {
		const root = LS.filters.isEntry() ?
			'property' : 'properties';
		const floor = this.floor;

		pbjs.addAdUnits({
			element: ad.el,
			code: ad.unit,
			ortb2Imp: {
				bidfloor: floor,
				bidfloorcur: 'USD',
				ext: {
					gpid: `/${root}/${ad.position}`
				}
			},
			mediaTypes: {
				banner: {
					sizes: ad.sizes.slice(1)
				},
				native: {
					image: {
						required: true,
						sizes: [1200, 627]
					},
					title: {
						required: true,
						len: 90
					},
					body: {
						len: 180
					}
				}
			},
			bids: $.env() === 'local' ? [] : [
				{
					bidder: 'cordless',
					params: {
						server: 'https://srv.cordlessmedia.com',
						zone: root === 'properties' ?
							159965 : 159966
					}
				},
				{
					bidder: 'equativ',
					params: {
						networkId: 5654,
						siteId: 776957,
						pageId: 2209536,
						formatId: 154957,
						bidFloor: floor
					}
				},
				{
					bidder: 'ix',
					params: {
						siteId: '900892'
					}
				},
				{
					bidder: 'medianet',
					params: {
						cid: '8CUASB4P3',
						crid: '599585305',
						bidfloor: floor
					}
				},
				{
					bidder: 'msft',
					params: {
						placement_id: 27532336,
						allow_smaller_sizes: true
					}
				},
				{
					bidder: 'triplelift',
					params: {
						inventoryCode: 'LandSearch_Properties_Card_Prebid',
						floor: floor
					}
				}
			]
		});
	},

	/**
	 * Handle response
	 *
	 * @param {Object} ad
	 */
	handle(ad) {
		if (ad.done) {
			return;
		}

		ad.done = true;

		googletag.cmd.push(() => {
			if (pbjs.setTargetingForGPTAsync) {
				pbjs.setTargetingForGPTAsync();
			}

			googletag.pubads()
				.refresh([
					ad.slot
				]);

			if (pbjs.removeAdUnit) {
				pbjs.removeAdUnit(ad.unit);
			}
		});
	},

	/**
	 * Verify ad support
	 */
	recover() {
		const scope = this;

		if (Apt.ads.allowed || ! scope.units) {
			return;
		}

		scope.units.parent()
			.addClass('-recover');

		if (! scope.blocked) {
			scope.blocked = true;

			LS.analytics.event('ad_block');
		}
	}
});